module.exports = __webpack_public_path__ + "static/media/startupsmartpackages-first@2x.94fa2921.png";